import { pathname, onboardingUrls, forwardUrlParams, isProd } from '.';
import { getUserAttributes } from './user';
import { preLoginUrls } from './path/path';

export function emptyBusinessInfo() {
  return {
    name: '',
    established: '',
    amazonUrl: '',
    numEmployees: '',
    monthlyRevenue: '',
    numProductsSold: '',
  };
}

function setOnboardingPage(
  onboardingStep: number,
  history: any,
  setActiveStep: (...args) => any,
) {
  let onboardingPage = null;
  for (const page in pathname.onboarding.main) {
    if (
      pathname.onboarding.main[page] &&
      pathname.onboarding.main[page]?.stepInStepper?.toString() ===
        onboardingStep
    ) {
      onboardingPage = pathname.onboarding.main[page]?.url;
    }
  }
  if (!onboardingPage) {
    onboardingPage = pathname.onboarding.main.sellerId.url;
  }
  setActiveStep(onboardingStep);
  history.push({ pathname: onboardingPage, search: forwardUrlParams() });
}

export async function enforceOnboarding(
  setHasCompletedOnboarding: (state: boolean) => void,
  setActiveStep: (num: number) => void,
  history: any,
) {
  const user = await getUserAttributes();
  if (Object.keys(user).length > 0) {
    const currentPage = window.location.pathname;
    const completedOnboarding = user['custom:completed_onboarding'];
    const onOnboardingPage = onboardingUrls.includes(currentPage);
    const onLoginPage = preLoginUrls.includes(currentPage);
    if (completedOnboarding === '1' || completedOnboarding === undefined) {
      setHasCompletedOnboarding(true);
      if (onLoginPage || (isProd() && onOnboardingPage)) {
        history.push(pathname.dashboard.url);
      }
    } else if (onOnboardingPage) {
      setHasCompletedOnboarding(false);
    } else {
      const onboardingStep = user['custom:onboarding_page'];
      setHasCompletedOnboarding(false);
      setOnboardingPage(onboardingStep, history, setActiveStep);
    }
  }
}

export function selectNewOption(
  options: any,
  setOptions: any,
  newOption: string,
) {
  const updatedOptions = options.map((option) => {
    option.selected = option.name === newOption ? true : false;
    return option;
  });
  setOptions(updatedOptions);
}

export function validateOptionSelected(
  options: Array<any>,
  setError: (...args) => any,
) {
  if (!options) return;
  let isOptionSelected = false;
  options.forEach((option) => {
    if (option.selected) isOptionSelected = true;
  });
  if (!isOptionSelected) {
    setError('Please select an option.');
  }
  return isOptionSelected;
}
